


















import Vue from 'vue';
import ObjectInfo from '@/components/cards/ObjectInfo.vue';

// eslint-disable-next-line no-restricted-imports
import listingHandlers from '@/legacy/assets/sor/listing_handlers';

export default Vue.extend({
  name: 'ObjectInfoSpaWrapper',
  components: {
    ObjectInfo,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    objectIdentifier(): string[] {
      return this.id.split(':');
    },
  },
  mounted() {
    listingHandlers(this.$el);
  },
  methods: {
    updateConfig(newValue: object, replace: boolean) {
      this.$emit('updateConfig', newValue, replace);
    },
  },
});
